import { render, staticRenderFns } from "./Mybook.vue?vue&type=template&id=81e2edca&scoped=true&"
import script from "./Mybook.vue?vue&type=script&lang=js&"
export * from "./Mybook.vue?vue&type=script&lang=js&"
import style0 from "./Mybook.vue?vue&type=style&index=0&id=81e2edca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e2edca",
  null
  
)

export default component.exports